<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="searchInfo.matCode" clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料批次" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="searchInfo.batchNo" clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="10" :xl="10">
          <el-form-item label="时间" class="EL-Form-Item">
            <el-date-picker
              style="width: 350px"
              v-model="searchInfo.date"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getMainData()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="原材料出入库周转天数">
        <el-button
          v-authority="'BACK_MENU7_M4_B1'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <!-- 展示 -->
      <h-table
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getMainData"
        :data="mainData"
        pagination
        :nowPage.sync="pagination.pageNum"
        :pageSize.sync="pagination.pageSize"
        :total.sync="pagination.total"
      >
        <el-table-column prop="fcCode" label="工厂编号" />
        <el-table-column prop="whCode" label="通道编号" />
        <el-table-column prop="matCode" label="物料编号" />
        <el-table-column prop="batchNo" label="物料批次" />
				<el-table-column prop="createMonth" label="月份" />
        <!-- <el-table-column prop="matQuanIn" label="收货数量" /> -->
        <!-- <el-table-column prop="matQuanOut" label="出库数量" /> -->
        <el-table-column prop="avgTimeIn" label="入库时间" />
        <el-table-column prop="avgTimeOut" label="出库时间" />
        <el-table-column prop="dateDiff" label="周转天数" />
      </h-table>
    </box>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "inventoryXADate",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      searchInfo: {
        matCode: "",
        batchNo: "",
        fcCode: localStorage.getItem("fcCode") || "",
        date: [],
      },
      taskTab: "0",

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,
    };
  },
  watch: {
    searchInfo: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getMainData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getMainData();
      }, 1000);
    },
    //获取数据
    getMainData() {
      this.$http
        .request({
          url: "/api/xa/getInOutDay",
          method: "GET",
          params: {
            fcCode: this.searchInfo.fcCode || null,
            matCode: this.searchInfo.matCode || null,
            batchNo: this.searchInfo.batchNo || null,
            pageNum: this.pagination.pageNum,
            pageSize: this.pagination.pageSize,
            beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
            endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
          },
        })
        .then((resp) => {
          this.loading--;
          if (resp.status == 100) {
            this.mainData = resp.data.list || [];
            this.pagination.total = resp.data.total;
          }
        })
        .catch((error) => {
          this.loading--;
        });
    },
    //重置
    resetData() {
      this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
      this.searchInfo = {
        matCode: "",
        batchNo: "",
        fcCode: localStorage.getItem("fcCode") || "",
        date: [],
      };
      //添加默认时间
      this.searchInfo.date.push(moment().subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss"));
      this.searchInfo.date.push(moment().format("YYYY-MM-DD HH:mm:ss"));
      this.getMainData();
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        fcCode: this.searchInfo.fcCode || null,
        matCode: this.searchInfo.matCode || null,
        batchNo: this.searchInfo.batchNo || null,
        beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
        endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/xa/getInOutDay",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        const tHeader = [
          "工厂编号",
          "通道编号",
          "物料编号",
          "物料批次",
          "月份",
          // "收货数量",
          // "出库数量",
          "入库时间",
          "出库时间",
          "周转天数",
        ];
        const filterVal = [
          "fcCode",
          "whCode",
          "matCode",
          "batchNo",
		  		"createMonth",
          // "matQuanIn",
          // "matQuanOut",
          "avgTimeIn",
          "avgTimeOut",
          "dateDiff",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "原材料出入库周转天数",
        });
        this.logContent = "导出";
        this.logRemarks = "write_xa：导出原材料出入库周转天数";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "原材料出入库周转天数",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
  activated() {
    //添加默认时间
    this.searchInfo.date = [];
    this.searchInfo.date.push(moment().subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss"));
    this.searchInfo.date.push(moment().format("YYYY-MM-DD HH:mm:ss"));

    /* 获取首页的数据 */
    // this.getMainData();
  },
};
</script>

<style scoped>
</style>